import Wix, { subscribe } from '../../tpa/Wix';

import { IStyleParams } from '@wix/podcasts-common/dist/style-params';

import { IStyleParamsClient, IThemeColors, IThemeFonts } from '../types';

class StyleParamsClientWithSDK implements IStyleParamsClient {
  async get(): Promise<{
    styleParams: IStyleParams;
    themeColors: IThemeColors;
    themeFonts: IThemeFonts;
  }> {
    const [styleParams, themeColors, themeFonts] = await Promise.all([
      Wix.Styles.getStyleParams(),
      Wix.Styles.getSiteColors(),
      Wix.Styles.getSiteTextPresets(),
    ]);

    return {
      styleParams,
      themeColors,
      themeFonts,
    };
  }

  /**
   * Subscribe style params changed
   * @returns - unsubscribe function
   */
  subscribe(fn: (styleParams: IStyleParams) => void): Function {
    return subscribe(Wix.Events.STYLE_PARAMS_CHANGE, fn);
  }
}

export default StyleParamsClientWithSDK;
